import React from 'react'
import Img from '../../images/eu.jpg'

import * as S from './styles'

const Avatar = () => (
  <S.AvatarWrapper>
    <S.Avatar src={Img} />
  </S.AvatarWrapper>
)

export default Avatar
